import "core-js/modules/es.array.splice";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    conditions: {
      type: Object
    },
    gradeData: {
      type: Array
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      data: [],
      layerList: [],
      form: {
        isCrossLevel: 0,
        isTighten: 1,
        //是否紧缩
        layer: 1,
        bonusTag: 0
      }
    };
  },
  mounted: function mounted() {
    var data = [];

    for (var i = 0; i < 5; i++) {
      data.push({
        id: i + 1,
        name: i + 1 + '代'
      });
    }

    this.layerList = data;

    if (this.conditions) {
      this.data = this.conditions.data;

      for (var key in this.form) {
        this.form[key] = this.conditions[key];
      }
    }
  },
  methods: {
    clickDelete: function clickDelete(index, row) {
      var tmp = this.$tempModel.deepCopy(this.data);
      tmp.splice(index, 1);
      this.data = tmp;
    },
    clickAddCond: function clickAddCond() {
      this.data.push({
        grade: '',
        rate: ''
      });
    },
    clickAddAllCond: function clickAddAllCond() {
      for (var i = 0; i < this.gradeData.length; i++) {
        var item = this.gradeData[i];
        this.data.push({
          grade: item.tag,
          rate: 0
        });
      }
    },
    getParams: function getParams() {
      var params = this.form;
      params.data = this.data;
      return this.$tempModel.deepCopy(params);
    }
  }
};